import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { User } from '../interfaces/user';
import { ConversationService } from '../services/conversation.service';
import { AuthenticationService } from '../services/authentication.service';
import { AngularFireStorage } from '@angular/fire/storage';

@Component({
  selector: 'app-conversation',
  templateUrl: './conversation.component.html',
  styleUrls: ['./conversation.component.css']
})
export class ConversationComponent implements OnInit {
  frienduid: any;
  friend: User;
  user: User;
  conversatioId : string;
  textMessage: string;
  conversations : any[];
  shake: boolean=false;
  picture: any;
  croppedImage: any;
  constructor(
    private activateRoute: ActivatedRoute,
    private userService:UserService,
    private conversationService: ConversationService,
    private authenticationService: AuthenticationService,
    private firebaseStorage: AngularFireStorage
    ) { 
    this.frienduid = this.activateRoute.snapshot.params['uid'];

    this.authenticationService.getStatus().subscribe((session)=>{
      this.userService.getUserById(session.uid).valueChanges().subscribe((user: User)=>{
        this.user = user;
        this.userService.getUserById(this.frienduid).valueChanges().subscribe(
          (data: User)=>{
            this.friend= data;
            const ids = [this.user.uid, this.friend.uid].sort();
            this.conversatioId = ids.join('|');
            this.getConversations();
          },
          (error)=>{
            console.log(error);
          }
        );
      })
    })
  }
  ngOnInit() {
  }
  sendMessage(){
    const message = {
      uid: this.conversatioId,
      timestamp: Date.now(),
      text: this.textMessage,
      sender: this.user.uid,
      receiver: this.friend.uid,
      type: 'text'
    }
    this.conversationService.createConversation(message).then(()=>{
      this.textMessage = '';
    }).catch((error)=>{
      console.log(error);
    });
  }
  sendZumbido(){
    const message = {
      uid: this.conversatioId,
      timestamp: Date.now(),
      text: null,
      sender: this.user.uid,
      receiver: this.friend.uid,
      type: 'zumbido'
    }
    this.conversationService.createConversation(message).then(()=>{ });
    this.doZumbido();
  }
  saveImageMessage(url){
    const message = {
      uid: this.conversatioId,
      timestamp: Date.now(),
      text: url,
      sender: this.user.uid,
      receiver: this.friend.uid,
      type: 'image'
    }
    this.conversationService.createConversation(message).then(()=>{ });
  }
  doZumbido() {
    const audio = new Audio('assets/sound/zumbido.m4a');
    audio.play();
    this.shake = true;
    window.setTimeout(()=>{
      this.shake = false;
    }, 1000);
  }
  getConversations(){
    this.conversationService.getConversation(this.conversatioId).valueChanges().subscribe(
      (data)=>{
        this.conversations = data;
        this.conversations
        this.conversations.forEach(message => {
          if(message.seen){
            message.seen = true;
            this.conversationService.editConversation(message);
            if(message.type=='text'){
              const audio = new Audio('assets/sound/new_message.m4a');
              audio.play();
            }else if(message.type=='zumbido'){
              this.doZumbido();
            }
          }
        });
        console.log(data);
      },
      (error)=>{
        console.log(error);
      }
    );
  }

  preview(event){
    debugger;

    this.getBase64(event.srcElement.files[0]).then((data)=>{
      this.croppedImage = data;
    });

  }
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = reader.result;
        //.toString().replace(/^data:(.*,)?/, '');
        //if ((encoded.length % 4) > 0) {
          //encoded += '='.repeat(4 - (encoded.length % 4));
        //}
        resolve(encoded);
      };
      reader.onerror = error => reject(error);
    });
  }
  sendImage(event){
debugger;
    const currentImagenId = Date.now();
    const pictures = this.firebaseStorage.ref('pictures/'+currentImagenId+'.jpg').putString(this.croppedImage, 'data_url');
    pictures.then((result)=>{
      this.picture = this.firebaseStorage.ref('pictures/'+currentImagenId+'.jpg').getDownloadURL();
      this.picture.subscribe((p)=>{
        this.saveImageMessage(p);
        alert("imagen enviada");
      });
    }).catch((error)=>{
      console.log(error);
    });
  }
}
